<template>
  <app-header class="flex justify-between pl-10 pr-1/10">
    <div class="flex items-center">
      <bot-selector :default-bot-id="botId"
                    class="w-52"
                    @change="changeBot"
      />
      <div v-for="({ name, label, component, classes }) in breadcrumbs" :key="name" class="flex">
        <span class="text-gray mx-5">></span>
        <component :is="component"
                   :to="{ name }"
                   class="text-gray-dark"
                   :class="classes"
        >
          {{ label }}
        </component>
      </div>
    </div>
  </app-header>
</template>

<script>
import AppHeader from '@/components/common/AppHeader'
import BotSelector from '@/components/common/BotSelector'
import { ROUTE_NAMES } from '@/router'
import answerService from '@/services/amio/answer.service'
import answerModule from '@/store/modules/answer.module'

const BREADCRUMBS_CONFIG = [
  { name: ROUTE_NAMES.answers, label: 'Answers' },
  { name: ROUTE_NAMES.answersReport, label: 'Promotion Report' }
]

export default {
  name: 'AnswersHeader',
  components: {
    AppHeader,
    BotSelector
  },
  props: {
    botId: {
      type: String,
      default: ''
    },
    displayReportStatus: {
      type: Boolean,
      default: false
    },
    displayLastReportInfo: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    breadcrumbs() {
      const { name: routeName } = this.$route
      const currentBreadcrumbIndex = BREADCRUMBS_CONFIG.findIndex(({ name }) => name === routeName)
      let breadcrumbs = []
      for (let i = 0; i < currentBreadcrumbIndex + 1; i++) {
        const config = BREADCRUMBS_CONFIG[i]
        if (currentBreadcrumbIndex === i) {
          breadcrumbs.push({ ...config, component: 'span', classes: '' })
        } else {
          breadcrumbs.push({ ...config, component: 'router-link', classes: 'p-3 border rounded hover:bg-soft' })
        }
      }
      return breadcrumbs
    }
  },

  watch: {
    botId: {
      handler: function (id) {
        this.loadAnswers(id)
      },
      immediate: true
    }
  },

  methods: {
    changeBot(botId) {
      if (this.botId === botId) return

      this.$emit('update:loaders', true)
      this.$router.push({ name: ROUTE_NAMES.answers, params: { botId } })
    },

    loadAnswers(botId) {
      answerService.list(botId)
        .then(answers => {
          answerModule.setAnswerList(answers)
          this.$emit('update:loaders', false)
        })
    },

    mounted() {
      this.loadAnswers(this.botId)
    }
  }
}
</script>

<style scoped>

</style>
